/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

"use client"

import { ChevronRight, type LucideIcon } from "lucide-react"
import { useNavigate } from "react-router-dom"

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible"
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@/components/ui/sidebar"

export function NavMain({
  items,
  setActive,
  setAnalyticsTab,
  setApiTab,
}: {
  items: {
    title: string
    url: string
    icon?: LucideIcon
    isActive?: boolean
    isAdmin?: boolean
    items?: {
      title: string
      url: string
    }[]
  }[]
  setActive: (active: string) => void
  setAnalyticsTab?: (tab: string) => void
  setApiTab?: (tab: string) => void
}) {
  const handleItemClick = (itemTitle: string) => {
    setActive(itemTitle)
  }

  const handleSubItemClick = (itemTitle: string, subItemTitle: string) => {
    setActive(itemTitle)
    if (itemTitle === 'Analytics') {
      setAnalyticsTab?.(subItemTitle)
    } else if (itemTitle === 'API') {
      setApiTab?.(subItemTitle)
    }
  }

  const navigate = useNavigate();
  
  return (
    <SidebarGroup>
      <SidebarGroupLabel>LIRA</SidebarGroupLabel>
      <SidebarMenu>
        {items.map((item) => (
          <Collapsible
            key={item.title}
            asChild
            defaultOpen={item.isActive}
            className="group/collapsible"
          >
            <SidebarMenuItem>
              <CollapsibleTrigger asChild>
                <SidebarMenuButton 
                  onClick={() => {
                    if (item.isAdmin) {
                      navigate(item.url);
                    } else if (!item.items || item.items.length === 0) {
                      handleItemClick(item.title);
                    }
                  }} 
                  tooltip={item.title}
                >
                  {item.icon && <item.icon />}
                  <span>{item.title}</span>
                  {!item.isAdmin && <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />}
                </SidebarMenuButton>
              </CollapsibleTrigger>
              <CollapsibleContent>
                <SidebarMenuSub>
                  {item.items?.map((subItem) => (
                    <SidebarMenuSubItem key={subItem.title}>
                      <SidebarMenuSubButton 
                        onClick={() => handleSubItemClick(item.title, subItem.title)}
                        asChild
                      >
                        <a href={subItem.url}>
                          <span>{subItem.title}</span>
                        </a>
                      </SidebarMenuSubButton>
                    </SidebarMenuSubItem>
                  ))}
                </SidebarMenuSub>
              </CollapsibleContent>
            </SidebarMenuItem>
          </Collapsible>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
}
